"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONSchemasInterface = exports.esseSchema = void 0;
const schema_1 = __importDefault(require("@exabyte-io/esse.js/schema"));
const ajv_1 = __importDefault(require("ajv"));
const json_schema_deref_sync_1 = __importDefault(require("json-schema-deref-sync"));
const json_schema_merge_allof_1 = __importDefault(require("json-schema-merge-allof"));
exports.esseSchema = schema_1.default;
const schemasCache = new Map();
function isEsseSchema(schema) {
    return Boolean(schema === null || schema === void 0 ? void 0 : schema.$id);
}
function removeSchemaIdsAfterAllOf(schema, clean = false) {
    if (clean && isEsseSchema(schema)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { $id, ...restSchema } = schema;
        return restSchema;
    }
    if (Array.isArray(schema)) {
        return schema.map((item) => removeSchemaIdsAfterAllOf(item));
    }
    if (typeof schema !== "object" || schema === null) {
        return schema;
    }
    if (schema.allOf) {
        const { allOf, ...restSchema } = schema;
        return {
            allOf: allOf.map((innerSchema) => removeSchemaIdsAfterAllOf(innerSchema, true)),
            ...restSchema,
        };
    }
    return Object.fromEntries(Object.entries(schema).map(([key, value]) => {
        return [key, removeSchemaIdsAfterAllOf(value)];
    }));
}
class JSONSchemasInterface {
    static schemaById(schemaId) {
        if (schemasCache.size === 0) {
            JSONSchemasInterface.registerGlobalSchema(exports.esseSchema);
        }
        return schemasCache.get(schemaId);
    }
    /**
     *
     * @param globalSchema
     */
    static registerGlobalSchema(globalSchema) {
        if (JSONSchemasInterface._schema === globalSchema) {
            // performance optimization:
            // skip resolving as we already did it for the same globalSchema object
            return;
        }
        JSONSchemasInterface._schema = globalSchema;
        const { definitions } = (0, json_schema_deref_sync_1.default)(globalSchema);
        schemasCache.clear();
        if (!definitions) {
            return;
        }
        Object.values(definitions)
            .filter(isEsseSchema)
            .forEach((originalSchema) => {
            const schema = (0, json_schema_merge_allof_1.default)(removeSchemaIdsAfterAllOf(originalSchema, false), {
                resolvers: {
                    defaultResolver: json_schema_merge_allof_1.default.options.resolvers.title,
                },
            });
            if (schema.$id) {
                schemasCache.set(schema.$id, schema);
            }
        });
    }
    /**
     * @example <caption>Search by $id regex</caption>
     * JSONSchemasInterface.matchSchema({
     *   $id: {
     *     $regex: 'software-application'
     *   }
     * })
     *
     * @example <caption>Search by $id and title regex</caption>
     * JSONSchemasInterface.matchSchema({
     *   $id: {
     *     $regex: 'software-application'
     *   },
     *   title: {
     *     $regex: 'application'
     *   }
     * })
     */
    static matchSchema(query) {
        const searchFields = Object.keys(query);
        return Array.from(schemasCache.values()).find((schema) => {
            return searchFields.every((field) => {
                const queryField = query[field];
                const schemaField = schema[field];
                if (!queryField || typeof schemaField !== "string") {
                    return;
                }
                return new RegExp(queryField.$regex).test(schemaField);
            });
        });
    }
    /**
     * Create validation function for schema with schemaId
     */
    static resolveJsonValidator(schemaId, options = {}) {
        // @ts-ignore TODO: update Ajv validator
        const ajv = new ajv_1.default(options);
        const schema = this.schemaById(schemaId);
        if (!schema) {
            return;
        }
        return ajv.compile(schema);
    }
    /**
     * Register global schema only if none has been registered yet.
     * @param globalSchema
     */
    static registerGlobalSchemaIfEmpty(globalSchema) {
        if (!JSONSchemasInterface._schema) {
            JSONSchemasInterface.registerGlobalSchema(globalSchema);
        }
    }
}
exports.JSONSchemasInterface = JSONSchemasInterface;
JSONSchemasInterface._schema = null;
